import { Component } from '@angular/core';
import { ProductService } from 'src/app/service/product.service';
import { Product } from 'src/app/types/types';
import Swiper from 'swiper';
// import Swiper core and required modules
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  A11y,
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

@Component({
  selector: 'app-trending-products',
  templateUrl: './trending-products.component.html',
  styleUrls: ['./trending-products.component.css']
})
export class TrendingProductsComponent {

  loading : boolean = true;
  constructor(
    private productService : ProductService
  ) { 
    this.productService.getTrendingProducts().subscribe((res: Product[]) => {
      this.products = res;
      this.loading = false;
    });
  }

  swiper : Swiper;
  products : Product[];

  onSwiper(swiper) {
    this.swiper = swiper;
  }

  onSlideChange() {
    console.log('slide change');
  }

  get getSlidesPerView() {
    return window.screen.availWidth > 1000 ? "4" : "2" 
  }
}